import { currencyMap, POS } from '../constants';
import { Price } from '../schemas/flightOffers/price';

type Args = {
  outboundCabinPrice?: Price;
  inboundCabinPrice?: Price;
};

export function getTotalPoints({ outboundCabinPrice, inboundCabinPrice }: Args) {
  let totalPoints = outboundCabinPrice?.totalPrice ?? 0;
  let discountedPoints = outboundCabinPrice?.type === 'points' ? outboundCabinPrice.discountedPoints : totalPoints;

  if (inboundCabinPrice) {
    const inboundTotalPoints = inboundCabinPrice?.totalPrice ?? 0;
    totalPoints += inboundTotalPoints;
    discountedPoints += inboundCabinPrice?.type === 'points' ? inboundCabinPrice?.discountedPoints : inboundTotalPoints;
  }

  return { totalPoints, discountedPoints };
}

export const formatPoints = (value: number, pos: string, includeUnit = true) => {
  const posEnum = pos as POS;

  const points = getFormattedPoints(value, posEnum);

  if (!includeUnit) {
    return points;
  }

  return `${points} ${getPointsShort(posEnum)}`;
};

export const formatPointsWithTranslation = (value: number, pos: string, pointsText: string) => {
  const posEnum = pos as POS;
  const points = getFormattedPoints(value, posEnum);
  return `${points} ${pointsText}`;
};

const getFormattedPoints = (value: number, posEnum: POS) => {
  const config = currencyMap[posEnum];
  if (!config) throw new Error(`Invalid POS: ${posEnum}`);
  const { locale } = config;

  const formatter = new Intl.NumberFormat(locale);
  return formatter.format(value ?? 0);
};

const getPointsShort = (pos: POS) => {
  switch (pos) {
    case POS.DE:
      return 'Pkte.';
    case POS.ES:
      return 'ptos.';
    case POS.JP:
      return 'ポイント';
    case POS.CN:
      return '积分';
    default:
      return 'p';
  }
};
